import React from 'react'

import { Table, Row, Col } from '_zari/core'

import { EstadosOSE } from 'constants/index'

const ListaDocumentosSection = ({ documentos }) => {
  return (
    <Row>
      <Col md={12} className='px-4 py-2'>
        <Table.ClientSide
          // ref={tablaRef}
          filas={documentos}
          headRows={[
            { label: 'RUC' },
            { label: 'RAZ. SOCIAL' },
            { label: 'TIPO DOC.' },
            { label: 'NUM-SERIE' },
            { label: 'EMITIDA' },
            { label: 'ESTADO' }
          ]}
          rowTemplate={row => (
            <Table.Row hover key={row._id}>
              <Table.Cell>{row.ruc || '--'}</Table.Cell>
              <Table.Cell>{row.razonSocial || '--'}</Table.Cell>
              <Table.Cell>{row.tipoDocumento || '--'}</Table.Cell>
              <Table.Cell>{`${row.serieDocumento}-${row.numeroDocumento}` || '--'}</Table.Cell>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{row.estadoOSE ? EstadosOSE.__dictionary[row.estadoOSE].nombre : '--'}</Table.Cell>
            </Table.Row>
          )}
        />
      </Col>
    </Row>
  )
}

export default React.memo(ListaDocumentosSection)
